import { filterActiveInvoices } from "../../../../../utils/invoiceVisibility";

// Invoice workspace carts must have an actual, non-voided invoice in this
// project. The server list resolves legacy invoiceRelationships links and
// deliberately excludes unowned project-wide/orphan cart snapshots.
export const hasActiveInvoices = (invoices = []) =>
  filterActiveInvoices(invoices).some((invoice) => String(invoice?.id ?? "").trim() !== "");

export const getInvoiceOwnedCarts = ({ invoices = [], carts = [] } = {}) => {
  const invoiceIds = new Set(
    filterActiveInvoices(invoices)
      .map((invoice) => String(invoice?.id ?? "").trim())
      .filter(Boolean)
  );
  const seen = new Set();
  return (Array.isArray(carts) ? carts : [])
    .filter((cart) => {
      const key = String(cart?.invoicingCartKey ?? "").trim();
      const owner = String(cart?.linkedInvoiceId ?? "").trim();
      const lifecycle = String(cart?.lifecycleStatus ?? "").trim().toLowerCase();
      if (!key || !invoiceIds.has(owner) || ["deleted", "archived"].includes(lifecycle) || seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .sort((left, right) => {
      const leftTime = Date.parse(left?.updatedAt || left?.createdAt || "") || 0;
      const rightTime = Date.parse(right?.updatedAt || right?.createdAt || "") || 0;
      if (leftTime !== rightTime) return rightTime - leftTime;
      const leftInvoice = Number(left?.linkedInvoiceId);
      const rightInvoice = Number(right?.linkedInvoiceId);
      if (Number.isFinite(leftInvoice) && Number.isFinite(rightInvoice) && leftInvoice !== rightInvoice) {
        return rightInvoice - leftInvoice;
      }
      return String(right?.invoicingCartKey || "").localeCompare(String(left?.invoicingCartKey || ""));
    });
};

export const hasInvoiceOwnedCart = (options = {}) => getInvoiceOwnedCarts(options).length > 0;

// Preserve the person's explicit selection while it still belongs to a valid
// invoice; otherwise choose the most recently updated invoice-owned cart.
export const selectInvoiceOwnedCartKey = ({ carts = [], selectedKey = null, invoiceId = null } = {}) => {
  const scoped = invoiceId == null
    ? carts
    : carts.filter((cart) => String(cart?.linkedInvoiceId || "") === String(invoiceId));
  const selected = scoped.find((cart) => cart?.invoicingCartKey === selectedKey);
  return selected?.invoicingCartKey || scoped[0]?.invoicingCartKey || null;
};

export const formatInvoiceCartChoice = (cart = {}, available = []) => {
  const key = String(cart.invoicingCartKey || '');
  const invoiceId = cart.linkedInvoiceNumber || cart.linkedInvoiceId || 'Unknown';
  const duplicates = (Array.isArray(available) ? available : [])
    .filter((entry) => String(entry?.linkedInvoiceId || '') === String(cart.linkedInvoiceId || '')).length > 1;
  return [
    `Invoice #${invoiceId}`,
    cart.lifecycleStatus || 'Saved',
    cart.revisionNumber ? `Rev ${cart.revisionNumber}` : null,
    duplicates && key ? `Cart …${key.slice(-6)}` : null,
  ].filter(Boolean).join(' · ');
};
